import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Circle, Pencil } from "lucide-react";

export default function ProfileCompletionCard({ profile }) {
  const navigate = useNavigate();
  const items = [
    { label: "Add a profile photo", done: Boolean(profile.photos?.length || profile.picture) },
    { label: "Write a short bio", done: Boolean(profile.bio) },
    { label: "Set your location", done: Boolean(profile.location) },
    { label: "Verify your photos", done: Boolean(profile.is_verified) },
  ];
  const done = items.filter((i) => i.done).length;
  if (done === items.length) return null;
  const pct = Math.round((done / items.length) * 100);

  return (
    <div className="mb-8 p-5 rounded-2xl bg-primary/5 border border-primary/20" data-testid="profile-completion-card">
      <div className="flex items-center justify-between mb-3">
        <p className="font-semibold flex items-center gap-2">
          <Pencil className="w-4 h-4 text-primary" /> Complete your profile
        </p>
        <span className="text-sm text-primary font-semibold" data-testid="completion-pct">{pct}%</span>
      </div>
      <div className="h-2 rounded-full bg-white/10 mb-4 overflow-hidden">
        <div className="h-full bg-primary rounded-full transition-all" style={{ width: `${pct}%` }} />
      </div>
      <ul className="space-y-2 mb-4">
        {items.map((i) => (
          <li
            key={i.label}
            className={`flex items-center gap-2 text-sm ${i.done ? "text-muted-foreground line-through" : ""}`}
          >
            {i.done ? (
              <CheckCircle2 className="w-4 h-4 text-green-400 shrink-0" />
            ) : (
              <Circle className="w-4 h-4 text-muted-foreground shrink-0" />
            )}
            {i.label}
          </li>
        ))}
      </ul>
      <p className="text-xs text-muted-foreground mb-3">
        Complete profiles get dramatically more views, favorites and date offers.
      </p>
      <Button
        size="sm"
        variant="outline"
        className="border-primary/40 text-primary hover:bg-primary/10"
        onClick={() => navigate("/settings")}
        data-testid="complete-profile-btn"
      >
        Finish in Settings
      </Button>
    </div>
  );
}
